import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface Event {
  id: string;
  type: string;
  payload: any;
}

export interface EventModel {
  event: Event | null;
}

const initialState: EventModel = {
  event: null,
};

export const events = createSlice({
  name: "eventsSlice",
  initialState,
  reducers: {
    setEvent: (state, action: PayloadAction<{ type: string; payload: any }>) => {
      state.event = {
        id: getUniqueId(),
        type: action.payload.type,
        payload: action.payload.payload,
      };
    },
  },
});

const eventsReducer = events.reducer;
const { setEvent } = events.actions;

export { eventsReducer, setEvent };

function getUniqueId(): string {
  const dateString = Date.now().toString(36);
  const randomness = Math.random().toString(36).substring(2);

  return dateString + randomness;
}
